const divisorForMillisecondsInHours = 36e5;
const isSmartbumped = (dateString) => {
    if (dateString === undefined) {
        return false;
    }
    const smartbumpMomentInMilliseconds = Date.parse(dateString);
    const currentMomentInMilliseconds = new Date().valueOf();
    const differenceInHours = (currentMomentInMilliseconds - smartbumpMomentInMilliseconds) /
        divisorForMillisecondsInHours;
    return differenceInHours < 24;
};

export { isSmartbumped as default };
//# sourceMappingURL=is-smartbumped.js.map
